module.exports = __webpack_public_path__ + "static/___005___Complimentary-membership-to-Laguna-Golf-Phuket.f6db5dad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/slider/___005___Complimentary-membership-to-Laguna-Golf-Phuket.jpg
// module id = 1281
// module chunks = 64098118039141